import { createAction } from 'typesafe-actions';

import { OffersCountTooltipTarget } from 'shared/types/offersCountTooltip/offersCountTooltipTarget';

export const setTargetOffersCountTooltip = createAction('offersCountTooltip/set_target')<OffersCountTooltipTarget>();
